import React, { useCallback, useEffect, useMemo } from 'react'; 
import TranslateManager from 'ts-translate-js';

const tr = TranslateManager.boundTR;

// Delivery helper functions
const PolicyType = {
    POLICY: "POLICY",
    DISCLAIMER: "DISCLAIMER"
};

type PolicyInfoProps = {
    policy: any,
    onCheckedChange: (id: number, checked: boolean) => void,
    raiseContentChanged: () => void

};    

export function PolicyInfo({policy, onCheckedChange, raiseContentChanged}: PolicyInfoProps) {

    useEffect(() => {
        if(raiseContentChanged != null) 
            raiseContentChanged();
    }, [raiseContentChanged]);

    const handleOnChange = useCallback((id, checked) => {
        onCheckedChange(id, checked);
    }, [onCheckedChange]);

    const handleUrlOnClick = useCallback((e, url) => {
        e.stopPropagation();
        e.preventDefault();

        window.open(url,'_blank');
    }, []);

    const render = useMemo(() => {
        const urlHasSomething = (policy.url != null && policy.url != "");
        const htmlHasSomething = (policy.body != null && policy.body != "");
        let checkboxText = null;
        let urlLink = null;
        let htmlCtl = null;

        if((policy.type == PolicyType.DISCLAIMER || policy.type == null) && htmlHasSomething)
            checkboxText = tr("J'ai lu et accepte la décharge");
        else if(policy.type == PolicyType.DISCLAIMER && urlHasSomething) {
            checkboxText = tr("J'ai lu et accepte la");
            //TODO: Refactor this as a button
            // eslint-disable-next-line sonarjs/anchor-is-valid
            urlLink = <a href="#" onClick={(e) => handleUrlOnClick(e, policy.url)}>{tr("décharge")}</a>;
        }
        else if(policy.type == PolicyType.POLICY && urlHasSomething) {
            checkboxText = tr("J'ai lu et accepte les");
            //TODO: Refactor this as a button
            // eslint-disable-next-line sonarjs/anchor-is-valid
            urlLink = <a href="#" onClick={(e) => handleUrlOnClick(e, policy.url)}>{tr("politiques d'achats")}</a>;
        }
        else if(policy.type == PolicyType.POLICY && htmlHasSomething)
            checkboxText = tr("J'ai lu et accepte les politiques d'achats");

        if(htmlHasSomething)
            htmlCtl = <div dangerouslySetInnerHTML={{__html: policy.body}} style={{maxHeight:"300px", overflowY: "scroll" }}></div>;
        // else
        // on pourra éventuellement supporter le markdown


        const title = (policy.title != null && policy.title != "") ?
            <h4>
                <i className="fa fa-file-text"></i>&nbsp;
                {/* TODO: Refactor this as a button */}
                {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
                <a href="#">{policy.title}</a>
            </h4>
            : null;

        return (<div key={policy.id} className="well">
                {title}
                {htmlCtl}
                <div className="checkbox">
                    <strong>
                        <label>
                            <input type="checkbox" onChange={(e) => handleOnChange(policy.id, e.target.checked)}></input> {checkboxText} {urlLink}
                        </label>
                    </strong>
                </div>
        </div>);
    }, [policy, handleOnChange, handleUrlOnClick]);

    return <div>{render}</div>;
}